const tokens = {
  "colors.bgBlue": {
    "value": "#E8F0F5",
    "variable": "var(--colors-bg-blue)"
  },
  "colors.bgGreen": {
    "value": "#EAF1E6",
    "variable": "var(--colors-bg-green)"
  },
  "colors.bgRed": {
    "value": "#FCE8ED",
    "variable": "var(--colors-bg-red)"
  },
  "colors.bgYellow": {
    "value": "#FFF6E0",
    "variable": "var(--colors-bg-yellow)"
  },
  "colors.fontBlack": {
    "value": "#12212E",
    "variable": "var(--colors-font-black)"
  },
  "colors.fontGreen": {
    "value": "#56783D",
    "variable": "var(--colors-font-green)"
  },
  "colors.fontGrey": {
    "value": "#3E5769",
    "variable": "var(--colors-font-grey)"
  },
  "colors.fontRed": {
    "value": "#CB1640",
    "variable": "var(--colors-font-red)"
  },
  "colors.fontLightRed": {
    "value": "#E04A6A",
    "variable": "var(--colors-font-light-red)"
  },
  "colors.blue": {
    "value": "#245B83",
    "variable": "var(--colors-blue)"
  },
  "colors.darkGrey": {
    "value": "#3E5769",
    "variable": "var(--colors-dark-grey)"
  },
  "colors.green": {
    "value": "#56783D",
    "variable": "var(--colors-green)"
  },
  "colors.grey": {
    "value": "#F3E5C1",
    "variable": "var(--colors-grey)"
  },
  "colors.lightBlue": {
    "value": "#728A9C",
    "variable": "var(--colors-light-blue)"
  },
  "colors.lightGrey": {
    "value": "#F7F1E7",
    "variable": "var(--colors-light-grey)"
  },
  "colors.lineGrey": {
    "value": "#DED1B1",
    "variable": "var(--colors-line-grey)"
  },
  "colors.turquoise": {
    "value": "#245B83",
    "variable": "var(--colors-turquoise)"
  },
  "colors.white": {
    "value": "#FFFFFF",
    "variable": "var(--colors-white)"
  },
  "colors.darkBlue": {
    "value": "#12212E",
    "variable": "var(--colors-dark-blue)"
  },
  "colors.royalBlue": {
    "value": "#245B83",
    "variable": "var(--colors-royal-blue)"
  },
  "colors.lightSkyBlue": {
    "value": "#728A9C",
    "variable": "var(--colors-light-sky-blue)"
  },
  "colors.slateGray": {
    "value": "#3E5769",
    "variable": "var(--colors-slate-gray)"
  },
  "colors.transparentWhite": {
    "value": "rgba(255, 255, 255, 0.2)",
    "variable": "var(--colors-transparent-white)"
  },
  "colors.lightBlack": {
    "value": "#12212E",
    "variable": "var(--colors-light-black)"
  },
  "colors.neutral.50": {
    "value": "#F7F1E7",
    "variable": "var(--colors-neutral-50)"
  },
  "colors.neutral.100": {
    "value": "#F3E5C1",
    "variable": "var(--colors-neutral-100)"
  },
  "colors.neutral.200": {
    "value": "#DED1B1",
    "variable": "var(--colors-neutral-200)"
  },
  "colors.neutral.300": {
    "value": "#C9B896",
    "variable": "var(--colors-neutral-300)"
  },
  "colors.neutral.400": {
    "value": "#A89478",
    "variable": "var(--colors-neutral-400)"
  },
  "colors.neutral.500": {
    "value": "#728A9C",
    "variable": "var(--colors-neutral-500)"
  },
  "colors.neutral.600": {
    "value": "#3E5769",
    "variable": "var(--colors-neutral-600)"
  },
  "colors.neutral.700": {
    "value": "#245B83",
    "variable": "var(--colors-neutral-700)"
  },
  "colors.neutral.800": {
    "value": "#0E2D44",
    "variable": "var(--colors-neutral-800)"
  },
  "colors.neutral.900": {
    "value": "#12212E",
    "variable": "var(--colors-neutral-900)"
  },
  "colors.neutral.950": {
    "value": "#0A141C",
    "variable": "var(--colors-neutral-950)"
  },
  "colors.brandAccent.50": {
    "value": "#FFF9EB",
    "variable": "var(--colors-brand-accent-50)"
  },
  "colors.brandAccent.100": {
    "value": "#FFF0CC",
    "variable": "var(--colors-brand-accent-100)"
  },
  "colors.brandAccent.200": {
    "value": "#FFE299",
    "variable": "var(--colors-brand-accent-200)"
  },
  "colors.brandAccent.300": {
    "value": "#FFD466",
    "variable": "var(--colors-brand-accent-300)"
  },
  "colors.brandAccent.400": {
    "value": "#FFC83D",
    "variable": "var(--colors-brand-accent-400)"
  },
  "colors.brandAccent.500": {
    "value": "#FFC01F",
    "variable": "var(--colors-brand-accent-500)"
  },
  "colors.brandAccent.600": {
    "value": "#FFC01F",
    "variable": "var(--colors-brand-accent-600)"
  },
  "colors.brandAccent.700": {
    "value": "#E0A610",
    "variable": "var(--colors-brand-accent-700)"
  },
  "colors.brandAccent.800": {
    "value": "#B8840C",
    "variable": "var(--colors-brand-accent-800)"
  },
  "colors.brandAccent.900": {
    "value": "#7A5708",
    "variable": "var(--colors-brand-accent-900)"
  },
  "colors.brandAccent.950": {
    "value": "#4A3505",
    "variable": "var(--colors-brand-accent-950)"
  },
  "colors.base.black": {
    "value": "#12212E",
    "variable": "var(--colors-base-black)"
  },
  "colors.base.white": {
    "value": "#ffffff",
    "variable": "var(--colors-base-white)"
  },
  "colors.brand.50": {
    "value": "#E8F0F5",
    "variable": "var(--colors-brand-50)"
  },
  "colors.brand.100": {
    "value": "#D0E0EB",
    "variable": "var(--colors-brand-100)"
  },
  "colors.brand.200": {
    "value": "#A8C2D4",
    "variable": "var(--colors-brand-200)"
  },
  "colors.brand.300": {
    "value": "#728A9C",
    "variable": "var(--colors-brand-300)"
  },
  "colors.brand.400": {
    "value": "#3E5769",
    "variable": "var(--colors-brand-400)"
  },
  "colors.brand.500": {
    "value": "#2E6A94",
    "variable": "var(--colors-brand-500)"
  },
  "colors.brand.600": {
    "value": "#245B83",
    "variable": "var(--colors-brand-600)"
  },
  "colors.brand.700": {
    "value": "#0E2D44",
    "variable": "var(--colors-brand-700)"
  },
  "colors.brand.800": {
    "value": "#12212E",
    "variable": "var(--colors-brand-800)"
  },
  "colors.brand.900": {
    "value": "#0A141C",
    "variable": "var(--colors-brand-900)"
  },
  "colors.brand.950": {
    "value": "#050A0F",
    "variable": "var(--colors-brand-950)"
  },
  "colors.steelFog.50": {
    "value": "#F7F1E7",
    "variable": "var(--colors-steel-fog-50)"
  },
  "colors.steelFog.100": {
    "value": "#DED1B1",
    "variable": "var(--colors-steel-fog-100)"
  },
  "colors.steelFog.200": {
    "value": "#C9B896",
    "variable": "var(--colors-steel-fog-200)"
  },
  "colors.steelFog.300": {
    "value": "#A89478",
    "variable": "var(--colors-steel-fog-300)"
  },
  "colors.steelFog.400": {
    "value": "#728A9C",
    "variable": "var(--colors-steel-fog-400)"
  },
  "colors.steelFog.500": {
    "value": "#3E5769",
    "variable": "var(--colors-steel-fog-500)"
  },
  "colors.steelFog.600": {
    "value": "#245B83",
    "variable": "var(--colors-steel-fog-600)"
  },
  "colors.steelFog.700": {
    "value": "#0E2D44",
    "variable": "var(--colors-steel-fog-700)"
  },
  "colors.steelFog.800": {
    "value": "#12212E",
    "variable": "var(--colors-steel-fog-800)"
  },
  "colors.steelFog.900": {
    "value": "#0A141C",
    "variable": "var(--colors-steel-fog-900)"
  },
  "colors.steelFog.950": {
    "value": "#050A0F",
    "variable": "var(--colors-steel-fog-950)"
  },
  "colors.copperTaupe.50": {
    "value": "#F7F1E7",
    "variable": "var(--colors-copper-taupe-50)"
  },
  "colors.copperTaupe.100": {
    "value": "#F3E5C1",
    "variable": "var(--colors-copper-taupe-100)"
  },
  "colors.copperTaupe.200": {
    "value": "#DED1B1",
    "variable": "var(--colors-copper-taupe-200)"
  },
  "colors.copperTaupe.300": {
    "value": "#C9B896",
    "variable": "var(--colors-copper-taupe-300)"
  },
  "colors.copperTaupe.400": {
    "value": "#A89478",
    "variable": "var(--colors-copper-taupe-400)"
  },
  "colors.copperTaupe.500": {
    "value": "#8A7660",
    "variable": "var(--colors-copper-taupe-500)"
  },
  "colors.copperTaupe.600": {
    "value": "#6B5A48",
    "variable": "var(--colors-copper-taupe-600)"
  },
  "colors.copperTaupe.700": {
    "value": "#4F4336",
    "variable": "var(--colors-copper-taupe-700)"
  },
  "colors.copperTaupe.800": {
    "value": "#3A3229",
    "variable": "var(--colors-copper-taupe-800)"
  },
  "colors.copperTaupe.900": {
    "value": "#12212E",
    "variable": "var(--colors-copper-taupe-900)"
  },
  "colors.copperTaupe.950": {
    "value": "#0A141C",
    "variable": "var(--colors-copper-taupe-950)"
  },
  "colors.error.50": {
    "value": "#FCE8ED",
    "variable": "var(--colors-error-50)"
  },
  "colors.error.100": {
    "value": "#F9D0DA",
    "variable": "var(--colors-error-100)"
  },
  "colors.error.200": {
    "value": "#F0A0B3",
    "variable": "var(--colors-error-200)"
  },
  "colors.error.300": {
    "value": "#E5708C",
    "variable": "var(--colors-error-300)"
  },
  "colors.error.400": {
    "value": "#D84068",
    "variable": "var(--colors-error-400)"
  },
  "colors.error.500": {
    "value": "#CB1640",
    "variable": "var(--colors-error-500)"
  },
  "colors.error.600": {
    "value": "#CB1640",
    "variable": "var(--colors-error-600)"
  },
  "colors.error.700": {
    "value": "#9E1132",
    "variable": "var(--colors-error-700)"
  },
  "colors.error.800": {
    "value": "#720C24",
    "variable": "var(--colors-error-800)"
  },
  "colors.error.900": {
    "value": "#460716",
    "variable": "var(--colors-error-900)"
  },
  "colors.error.950": {
    "value": "#2B040E",
    "variable": "var(--colors-error-950)"
  },
  "colors.yellow.50": {
    "value": "#FFF9EB",
    "variable": "var(--colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "#FFF0CC",
    "variable": "var(--colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "#FFE299",
    "variable": "var(--colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "#FFD466",
    "variable": "var(--colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "#FFC83D",
    "variable": "var(--colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "#FFC01F",
    "variable": "var(--colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "#E0A610",
    "variable": "var(--colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "#B8840C",
    "variable": "var(--colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "#7A5708",
    "variable": "var(--colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "#12212E",
    "variable": "var(--colors-yellow-900)"
  },
  "colors.yellow.950": {
    "value": "#0A141C",
    "variable": "var(--colors-yellow-950)"
  },
  "colors.gray.600": {
    "value": "#3E5769",
    "variable": "var(--colors-gray-600)"
  },
  "colors.gray.700": {
    "value": "#12212E",
    "variable": "var(--colors-gray-700)"
  },
  "zIndex.appBackdrop": {
    "value": 1000,
    "variable": "var(--z-index-app-backdrop)"
  },
  "zIndex.appModal": {
    "value": 1001,
    "variable": "var(--z-index-app-modal)"
  },
  "zIndex.sidebarBackdrop": {
    "value": 51,
    "variable": "var(--z-index-sidebar-backdrop)"
  },
  "zIndex.sidebar": {
    "value": 52,
    "variable": "var(--z-index-sidebar)"
  },
  "zIndex.modalBackdrop": {
    "value": 100,
    "variable": "var(--z-index-modal-backdrop)"
  },
  "zIndex.modal": {
    "value": 101,
    "variable": "var(--z-index-modal)"
  },
  "zIndex.splashScreen": {
    "value": 111,
    "variable": "var(--z-index-splash-screen)"
  },
  "zIndex.mobileMoreButton": {
    "value": 34,
    "variable": "var(--z-index-mobile-more-button)"
  },
  "zIndex.caseListsDisclaimer": {
    "value": 35,
    "variable": "var(--z-index-case-lists-disclaimer)"
  },
  "zIndex.mapSearchInputWrapper": {
    "value": 2,
    "variable": "var(--z-index-map-search-input-wrapper)"
  },
  "zIndex.tooltipPositioner": {
    "value": 100,
    "variable": "var(--z-index-tooltip-positioner)"
  },
  "zIndex.tooltipArrow": {
    "value": -1,
    "variable": "var(--z-index-tooltip-arrow)"
  },
  "zIndex.chatCausesSwitch": {
    "value": 50,
    "variable": "var(--z-index-chat-causes-switch)"
  },
  "zIndex.causes.bg": {
    "value": 1,
    "variable": "var(--z-index-causes-bg)"
  },
  "zIndex.causes.content": {
    "value": 3,
    "variable": "var(--z-index-causes-content)"
  },
  "zIndex.causes.container": {
    "value": 1,
    "variable": "var(--z-index-causes-container)"
  },
  "zIndex.causes.sparkle": {
    "value": 5,
    "variable": "var(--z-index-causes-sparkle)"
  },
  "zIndex.causes.peek": {
    "value": 100,
    "variable": "var(--z-index-causes-peek)"
  },
  "zIndex.bgPattern.base": {
    "value": 0,
    "variable": "var(--z-index-bg-pattern-base)"
  },
  "zIndex.bgPattern.middle": {
    "value": 1,
    "variable": "var(--z-index-bg-pattern-middle)"
  },
  "zIndex.bgPattern.top": {
    "value": 2,
    "variable": "var(--z-index-bg-pattern-top)"
  },
  "zIndex.remediations.backButton": {
    "value": 1,
    "variable": "var(--z-index-remediations-back-button)"
  },
  "spacing.modalPaddingMobile": {
    "value": "16px",
    "variable": "var(--spacing-modal-padding-mobile)"
  },
  "spacing.modalPaddingDesktop": {
    "value": "32px",
    "variable": "var(--spacing-modal-padding-desktop)"
  },
  "gradients.orangeGradient": {
    "value": "linear-gradient(231.14deg, rgba(255, 192, 31, 0.4) 0%, rgba(247, 241, 231, 0.4) 92.75%)",
    "variable": "var(--gradients-orange-gradient)"
  },
  "gradients.orangeBorderGradient": {
    "value": "linear-gradient(232.29deg, #FFC01F 1.1%, #FFFFFF 87.26%)",
    "variable": "var(--gradients-orange-border-gradient)"
  },
  "gradients.whiteLinearGradient": {
    "value": "linear-gradient(180deg, rgba(247, 241, 231, 0) 0%, #F7F1E7 100%)",
    "variable": "var(--gradients-white-linear-gradient)"
  },
  "breakpoints.desktop": {
    "value": "768px",
    "variable": "var(--breakpoints-desktop)"
  },
  "breakpoints.largeDesktop": {
    "value": "1280px",
    "variable": "var(--breakpoints-large-desktop)"
  },
  "sizes.breakpoint-desktop": {
    "value": "768px",
    "variable": "var(--sizes-breakpoint-desktop)"
  },
  "sizes.breakpoint-largeDesktop": {
    "value": "1280px",
    "variable": "var(--sizes-breakpoint-large-desktop)"
  },
  "colors.background.primary": {
    "value": "var(--colors-base-white)",
    "variable": "var(--colors-background-primary)"
  },
  "colors.background.primaryOnSolid": {
    "value": "var(--colors-light-black)",
    "variable": "var(--colors-background-primary-on-solid)"
  },
  "colors.background.secondary": {
    "value": "var(--colors-neutral-50)",
    "variable": "var(--colors-background-secondary)"
  },
  "colors.background.tertiary": {
    "value": "var(--colors-neutral-100)",
    "variable": "var(--colors-background-tertiary)"
  },
  "colors.background.quaternary": {
    "value": "var(--colors-neutral-200)",
    "variable": "var(--colors-background-quaternary)"
  },
  "colors.background.muted": {
    "value": "#FFFFFF",
    "variable": "var(--colors-background-muted)"
  },
  "colors.background.subtle.primary": {
    "value": "var(--colors-neutral-50)",
    "variable": "var(--colors-background-subtle-primary)"
  },
  "colors.background.subtle.brand": {
    "value": "var(--colors-brand-accent-50)",
    "variable": "var(--colors-background-subtle-brand)"
  },
  "colors.background.brand.primary": {
    "value": "var(--colors-neutral-100)",
    "variable": "var(--colors-background-brand-primary)"
  },
  "colors.background.brand.primarySubtle": {
    "value": "var(--colors-neutral-50)",
    "variable": "var(--colors-background-brand-primary-subtle)"
  },
  "colors.background.brand.secondary": {
    "value": "var(--colors-brand-accent-100)",
    "variable": "var(--colors-background-brand-secondary)"
  },
  "colors.background.brand.solid": {
    "value": "var(--colors-brand-800)",
    "variable": "var(--colors-background-brand-solid)"
  },
  "colors.background.brand.solidSubtle": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-background-brand-solid-subtle)"
  },
  "colors.background.brand.accent": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-background-brand-accent)"
  },
  "colors.background.brand.accentSolid": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-background-brand-accent-solid)"
  },
  "colors.background.brand.accentSolidHover": {
    "value": "var(--colors-brand-300)",
    "variable": "var(--colors-background-brand-accent-solid-hover)"
  },
  "colors.background.brand.utility": {
    "value": "var(--colors-brand-800)",
    "variable": "var(--colors-background-brand-utility)"
  },
  "colors.background.causesPanel": {
    "value": "var(--colors-brand-400)",
    "variable": "var(--colors-background-causes-panel)"
  },
  "colors.background.causesCard": {
    "value": "#FFFFFF14",
    "variable": "var(--colors-background-causes-card)"
  },
  "colors.background.causesCardHover": {
    "value": "#FFFFFF24",
    "variable": "var(--colors-background-causes-card-hover)"
  },
  "colors.background.error": {
    "value": "var(--colors-error-100)",
    "variable": "var(--colors-background-error)"
  },
  "colors.background.warn": {
    "value": "var(--colors-yellow-50)",
    "variable": "var(--colors-background-warn)"
  },
  "colors.background.success": {
    "value": "var(--colors-bg-green)",
    "variable": "var(--colors-background-success)"
  },
  "colors.background.disabled": {
    "value": "var(--colors-neutral-100)",
    "variable": "var(--colors-background-disabled)"
  },
  "colors.background.tagTransparent": {
    "value": "#FFFFFF14",
    "variable": "var(--colors-background-tag-transparent)"
  },
  "colors.foreground.primary": {
    "value": "var(--colors-brand-800)",
    "variable": "var(--colors-foreground-primary)"
  },
  "colors.foreground.primarySubtle": {
    "value": "var(--colors-brand-700)",
    "variable": "var(--colors-foreground-primary-subtle)"
  },
  "colors.foreground.secondary": {
    "value": "var(--colors-brand-400)",
    "variable": "var(--colors-foreground-secondary)"
  },
  "colors.foreground.tertiary": {
    "value": "var(--colors-brand-800)",
    "variable": "var(--colors-foreground-tertiary)"
  },
  "colors.foreground.quaternary": {
    "value": "var(--colors-brand-800)",
    "variable": "var(--colors-foreground-quaternary)"
  },
  "colors.foreground.primaryOnSolid": {
    "value": "var(--colors-neutral-50)",
    "variable": "var(--colors-foreground-primary-on-solid)"
  },
  "colors.foreground.brand.primary": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-foreground-brand-primary)"
  },
  "colors.foreground.brand.secondary": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-foreground-brand-secondary)"
  },
  "colors.foreground.brand.accent": {
    "value": "var(--colors-brand-accent-600)",
    "variable": "var(--colors-foreground-brand-accent)"
  },
  "colors.foreground.error.primary": {
    "value": "var(--colors-error-600)",
    "variable": "var(--colors-foreground-error-primary)"
  },
  "colors.foreground.warning.primary": {
    "value": "var(--colors-yellow-600)",
    "variable": "var(--colors-foreground-warning-primary)"
  },
  "colors.foreground.secondaryOnSolid": {
    "value": "var(--colors-brand-300)",
    "variable": "var(--colors-foreground-secondary-on-solid)"
  },
  "colors.foreground.disabled": {
    "value": "var(--colors-neutral-400)",
    "variable": "var(--colors-foreground-disabled)"
  },
  "colors.foreground.success": {
    "value": "var(--colors-green)",
    "variable": "var(--colors-foreground-success)"
  },
  "colors.text.brand.primary": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-text-brand-primary)"
  },
  "colors.text.brand.accent": {
    "value": "var(--colors-brand-accent-600)",
    "variable": "var(--colors-text-brand-accent)"
  },
  "colors.text.brand.secondary": {
    "value": "var(--colors-brand-500)",
    "variable": "var(--colors-text-brand-secondary)"
  },
  "colors.text.warning.primary": {
    "value": "var(--colors-yellow-200)",
    "variable": "var(--colors-text-warning-primary)"
  },
  "colors.text.quaternary": {
    "value": "var(--colors-neutral-500)",
    "variable": "var(--colors-text-quaternary)"
  },
  "colors.text.tertiary": {
    "value": "var(--colors-brand-800)",
    "variable": "var(--colors-text-tertiary)"
  },
  "colors.text.secondary": {
    "value": "var(--colors-brand-800)",
    "variable": "var(--colors-text-secondary)"
  },
  "colors.text.secondary.onSolid": {
    "value": "var(--colors-brand-300)",
    "variable": "var(--colors-text-secondary-on-solid)"
  },
  "colors.text.error.primary": {
    "value": "var(--colors-error-600)",
    "variable": "var(--colors-text-error-primary)"
  },
  "colors.text.primary": {
    "value": "var(--colors-brand-800)",
    "variable": "var(--colors-text-primary)"
  },
  "colors.text.primary.subtle": {
    "value": "var(--colors-brand-800)",
    "variable": "var(--colors-text-primary-subtle)"
  },
  "colors.text.primary.onSolid": {
    "value": "var(--colors-neutral-50)",
    "variable": "var(--colors-text-primary-on-solid)"
  },
  "colors.text.link": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-text-link)"
  },
  "colors.text.link.hover": {
    "value": "var(--colors-brand-300)",
    "variable": "var(--colors-text-link-hover)"
  },
  "colors.text.causesPanel.primary": {
    "value": "var(--colors-neutral-50)",
    "variable": "var(--colors-text-causes-panel-primary)"
  },
  "colors.text.causesPanel.muted": {
    "value": "var(--colors-brand-100)",
    "variable": "var(--colors-text-causes-panel-muted)"
  },
  "colors.text.causesPanel.pattern": {
    "value": "var(--colors-brand-300)",
    "variable": "var(--colors-text-causes-panel-pattern)"
  },
  "colors.text.disabled": {
    "value": "var(--colors-neutral-400)",
    "variable": "var(--colors-text-disabled)"
  },
  "colors.text.success": {
    "value": "var(--colors-green)",
    "variable": "var(--colors-text-success)"
  },
  "colors.border.brand.primary": {
    "value": "var(--colors-brand-300)",
    "variable": "var(--colors-border-brand-primary)"
  },
  "colors.border.brand.primarySolid": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-border-brand-primary-solid)"
  },
  "colors.border.brand.secondarySolid": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-border-brand-secondary-solid)"
  },
  "colors.border.brand.secondary": {
    "value": "var(--colors-brand-200)",
    "variable": "var(--colors-border-brand-secondary)"
  },
  "colors.border.brand.accent": {
    "value": "var(--colors-brand-accent-600)",
    "variable": "var(--colors-border-brand-accent)"
  },
  "colors.border.brand.accentHover": {
    "value": "var(--colors-brand-accent-700)",
    "variable": "var(--colors-border-brand-accent-hover)"
  },
  "colors.border.secondary.200": {
    "value": "var(--colors-neutral-200)",
    "variable": "var(--colors-border-secondary-200)"
  },
  "colors.border.secondary.solid": {
    "value": "var(--colors-neutral-600)",
    "variable": "var(--colors-border-secondary-solid)"
  },
  "colors.border.primary.300": {
    "value": "var(--colors-neutral-300)",
    "variable": "var(--colors-border-primary-300)"
  },
  "colors.border.primary.solid.700": {
    "value": "var(--colors-brand-700)",
    "variable": "var(--colors-border-primary-solid-700)"
  },
  "colors.border.onWarning": {
    "value": "var(--colors-yellow-600)",
    "variable": "var(--colors-border-on-warning)"
  },
  "colors.border.error": {
    "value": "var(--colors-error-600)",
    "variable": "var(--colors-border-error)"
  },
  "colors.border.disabled": {
    "value": "var(--colors-neutral-300)",
    "variable": "var(--colors-border-disabled)"
  },
  "colors.border.successSubtle": {
    "value": "var(--colors-green)",
    "variable": "var(--colors-border-success-subtle)"
  },
  "colors.border.errorSubtle": {
    "value": "var(--colors-error-300)",
    "variable": "var(--colors-border-error-subtle)"
  },
  "colors.border.causeCard": {
    "value": "#FFFFFF33",
    "variable": "var(--colors-border-cause-card)"
  },
  "colors.confirmedIconsBackground.100": {
    "value": "var(--colors-brand-500)",
    "variable": "var(--colors-confirmed-icons-background-100)"
  },
  "colors.confirmedIconsBackground.200": {
    "value": "var(--colors-brand-700)",
    "variable": "var(--colors-confirmed-icons-background-200)"
  },
  "colors.confirmedIconsBackground.300": {
    "value": "var(--colors-brand-800)",
    "variable": "var(--colors-confirmed-icons-background-300)"
  },
  "colors.confirmedIconsBackground.400": {
    "value": "var(--colors-steel-fog-500)",
    "variable": "var(--colors-confirmed-icons-background-400)"
  },
  "colors.confirmedIconsBackground.500": {
    "value": "var(--colors-steel-fog-600)",
    "variable": "var(--colors-confirmed-icons-background-500)"
  },
  "colors.confirmedIconsBackground.600": {
    "value": "var(--colors-steel-fog-700)",
    "variable": "var(--colors-confirmed-icons-background-600)"
  },
  "colors.confirmedIconsBackground.700": {
    "value": "var(--colors-copper-taupe-500)",
    "variable": "var(--colors-confirmed-icons-background-700)"
  },
  "colors.confirmedIconsBackground.800": {
    "value": "var(--colors-copper-taupe-600)",
    "variable": "var(--colors-confirmed-icons-background-800)"
  },
  "colors.confirmedIconsBackground.900": {
    "value": "var(--colors-copper-taupe-700)",
    "variable": "var(--colors-confirmed-icons-background-900)"
  },
  "gradients.causesHoverGradient": {
    "value": "var(--gradients-orange-gradient)",
    "variable": "var(--gradients-causes-hover-gradient)"
  },
  "gradients.causesHoverBorderGradient": {
    "value": "var(--gradients-orange-border-gradient)",
    "variable": "var(--gradients-causes-hover-border-gradient)"
  },
  "gradients.conversationFade": {
    "value": "var(--gradients-white-linear-gradient)",
    "variable": "var(--gradients-conversation-fade)"
  },
  "gradients.causesPatternMask": {
    "value": "linear-gradient(to bottom, rgba(0, 0, 0, 0.6), transparent 55%)",
    "variable": "var(--gradients-causes-pattern-mask)"
  },
  "gradients.aiAccentPrimary": {
    "value": "linear-gradient(135deg, #245B83 0%, #12212E 100%)",
    "variable": "var(--gradients-ai-accent-primary)"
  },
  "gradients.aiAccentDanger": {
    "value": "linear-gradient(134deg, #FFC01F -1.91%, #FF8A00 100%)",
    "variable": "var(--gradients-ai-accent-danger)"
  },
  "radii.causeCard": {
    "value": "16px",
    "variable": "var(--radii-cause-card)"
  },
  "borderWidths.causeCardSide": {
    "value": "1px",
    "variable": "var(--border-widths-cause-card-side)"
  },
  "spacing.causesCardGap": {
    "value": "8px",
    "variable": "var(--spacing-causes-card-gap)"
  },
  "spacing.-modalPaddingMobile": {
    "value": "calc(var(--spacing-modal-padding-mobile) * -1)",
    "variable": "var(--spacing-modal-padding-mobile)"
  },
  "spacing.-modalPaddingDesktop": {
    "value": "calc(var(--spacing-modal-padding-desktop) * -1)",
    "variable": "var(--spacing-modal-padding-desktop)"
  },
  "spacing.-causesCardGap": {
    "value": "calc(var(--spacing-causes-card-gap) * -1)",
    "variable": "var(--spacing-causes-card-gap)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.50": {
    "value": "var(--colors-color-palette-50)",
    "variable": "var(--colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    "value": "var(--colors-color-palette-100)",
    "variable": "var(--colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--colors-color-palette-200)",
    "variable": "var(--colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--colors-color-palette-300)",
    "variable": "var(--colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--colors-color-palette-400)",
    "variable": "var(--colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--colors-color-palette-500)",
    "variable": "var(--colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--colors-color-palette-600)",
    "variable": "var(--colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    "value": "var(--colors-color-palette-700)",
    "variable": "var(--colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    "value": "var(--colors-color-palette-800)",
    "variable": "var(--colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    "value": "var(--colors-color-palette-900)",
    "variable": "var(--colors-color-palette-900)"
  },
  "colors.colorPalette.950": {
    "value": "var(--colors-color-palette-950)",
    "variable": "var(--colors-color-palette-950)"
  },
  "colors.colorPalette.black": {
    "value": "var(--colors-color-palette-black)",
    "variable": "var(--colors-color-palette-black)"
  },
  "colors.colorPalette.white": {
    "value": "var(--colors-color-palette-white)",
    "variable": "var(--colors-color-palette-white)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--colors-color-palette-primary)",
    "variable": "var(--colors-color-palette-primary)"
  },
  "colors.colorPalette.primaryOnSolid": {
    "value": "var(--colors-color-palette-primary-on-solid)",
    "variable": "var(--colors-color-palette-primary-on-solid)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--colors-color-palette-secondary)",
    "variable": "var(--colors-color-palette-secondary)"
  },
  "colors.colorPalette.tertiary": {
    "value": "var(--colors-color-palette-tertiary)",
    "variable": "var(--colors-color-palette-tertiary)"
  },
  "colors.colorPalette.quaternary": {
    "value": "var(--colors-color-palette-quaternary)",
    "variable": "var(--colors-color-palette-quaternary)"
  },
  "colors.colorPalette.muted": {
    "value": "var(--colors-color-palette-muted)",
    "variable": "var(--colors-color-palette-muted)"
  },
  "colors.colorPalette.subtle.primary": {
    "value": "var(--colors-color-palette-subtle-primary)",
    "variable": "var(--colors-color-palette-subtle-primary)"
  },
  "colors.colorPalette.subtle.brand": {
    "value": "var(--colors-color-palette-subtle-brand)",
    "variable": "var(--colors-color-palette-subtle-brand)"
  },
  "colors.colorPalette.brand": {
    "value": "var(--colors-color-palette-brand)",
    "variable": "var(--colors-color-palette-brand)"
  },
  "colors.colorPalette.brand.primary": {
    "value": "var(--colors-color-palette-brand-primary)",
    "variable": "var(--colors-color-palette-brand-primary)"
  },
  "colors.colorPalette.brand.primarySubtle": {
    "value": "var(--colors-color-palette-brand-primary-subtle)",
    "variable": "var(--colors-color-palette-brand-primary-subtle)"
  },
  "colors.colorPalette.primarySubtle": {
    "value": "var(--colors-color-palette-primary-subtle)",
    "variable": "var(--colors-color-palette-primary-subtle)"
  },
  "colors.colorPalette.brand.secondary": {
    "value": "var(--colors-color-palette-brand-secondary)",
    "variable": "var(--colors-color-palette-brand-secondary)"
  },
  "colors.colorPalette.brand.solid": {
    "value": "var(--colors-color-palette-brand-solid)",
    "variable": "var(--colors-color-palette-brand-solid)"
  },
  "colors.colorPalette.solid": {
    "value": "var(--colors-color-palette-solid)",
    "variable": "var(--colors-color-palette-solid)"
  },
  "colors.colorPalette.brand.solidSubtle": {
    "value": "var(--colors-color-palette-brand-solid-subtle)",
    "variable": "var(--colors-color-palette-brand-solid-subtle)"
  },
  "colors.colorPalette.solidSubtle": {
    "value": "var(--colors-color-palette-solid-subtle)",
    "variable": "var(--colors-color-palette-solid-subtle)"
  },
  "colors.colorPalette.brand.accent": {
    "value": "var(--colors-color-palette-brand-accent)",
    "variable": "var(--colors-color-palette-brand-accent)"
  },
  "colors.colorPalette.accent": {
    "value": "var(--colors-color-palette-accent)",
    "variable": "var(--colors-color-palette-accent)"
  },
  "colors.colorPalette.brand.accentSolid": {
    "value": "var(--colors-color-palette-brand-accent-solid)",
    "variable": "var(--colors-color-palette-brand-accent-solid)"
  },
  "colors.colorPalette.accentSolid": {
    "value": "var(--colors-color-palette-accent-solid)",
    "variable": "var(--colors-color-palette-accent-solid)"
  },
  "colors.colorPalette.brand.accentSolidHover": {
    "value": "var(--colors-color-palette-brand-accent-solid-hover)",
    "variable": "var(--colors-color-palette-brand-accent-solid-hover)"
  },
  "colors.colorPalette.accentSolidHover": {
    "value": "var(--colors-color-palette-accent-solid-hover)",
    "variable": "var(--colors-color-palette-accent-solid-hover)"
  },
  "colors.colorPalette.brand.utility": {
    "value": "var(--colors-color-palette-brand-utility)",
    "variable": "var(--colors-color-palette-brand-utility)"
  },
  "colors.colorPalette.utility": {
    "value": "var(--colors-color-palette-utility)",
    "variable": "var(--colors-color-palette-utility)"
  },
  "colors.colorPalette.causesPanel": {
    "value": "var(--colors-color-palette-causes-panel)",
    "variable": "var(--colors-color-palette-causes-panel)"
  },
  "colors.colorPalette.causesCard": {
    "value": "var(--colors-color-palette-causes-card)",
    "variable": "var(--colors-color-palette-causes-card)"
  },
  "colors.colorPalette.causesCardHover": {
    "value": "var(--colors-color-palette-causes-card-hover)",
    "variable": "var(--colors-color-palette-causes-card-hover)"
  },
  "colors.colorPalette.error": {
    "value": "var(--colors-color-palette-error)",
    "variable": "var(--colors-color-palette-error)"
  },
  "colors.colorPalette.warn": {
    "value": "var(--colors-color-palette-warn)",
    "variable": "var(--colors-color-palette-warn)"
  },
  "colors.colorPalette.success": {
    "value": "var(--colors-color-palette-success)",
    "variable": "var(--colors-color-palette-success)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--colors-color-palette-disabled)",
    "variable": "var(--colors-color-palette-disabled)"
  },
  "colors.colorPalette.tagTransparent": {
    "value": "var(--colors-color-palette-tag-transparent)",
    "variable": "var(--colors-color-palette-tag-transparent)"
  },
  "colors.colorPalette.error.primary": {
    "value": "var(--colors-color-palette-error-primary)",
    "variable": "var(--colors-color-palette-error-primary)"
  },
  "colors.colorPalette.warning.primary": {
    "value": "var(--colors-color-palette-warning-primary)",
    "variable": "var(--colors-color-palette-warning-primary)"
  },
  "colors.colorPalette.secondaryOnSolid": {
    "value": "var(--colors-color-palette-secondary-on-solid)",
    "variable": "var(--colors-color-palette-secondary-on-solid)"
  },
  "colors.colorPalette.secondary.onSolid": {
    "value": "var(--colors-color-palette-secondary-on-solid)",
    "variable": "var(--colors-color-palette-secondary-on-solid)"
  },
  "colors.colorPalette.onSolid": {
    "value": "var(--colors-color-palette-on-solid)",
    "variable": "var(--colors-color-palette-on-solid)"
  },
  "colors.colorPalette.primary.subtle": {
    "value": "var(--colors-color-palette-primary-subtle)",
    "variable": "var(--colors-color-palette-primary-subtle)"
  },
  "colors.colorPalette.subtle": {
    "value": "var(--colors-color-palette-subtle)",
    "variable": "var(--colors-color-palette-subtle)"
  },
  "colors.colorPalette.primary.onSolid": {
    "value": "var(--colors-color-palette-primary-on-solid)",
    "variable": "var(--colors-color-palette-primary-on-solid)"
  },
  "colors.colorPalette.link": {
    "value": "var(--colors-color-palette-link)",
    "variable": "var(--colors-color-palette-link)"
  },
  "colors.colorPalette.link.hover": {
    "value": "var(--colors-color-palette-link-hover)",
    "variable": "var(--colors-color-palette-link-hover)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--colors-color-palette-hover)",
    "variable": "var(--colors-color-palette-hover)"
  },
  "colors.colorPalette.causesPanel.primary": {
    "value": "var(--colors-color-palette-causes-panel-primary)",
    "variable": "var(--colors-color-palette-causes-panel-primary)"
  },
  "colors.colorPalette.causesPanel.muted": {
    "value": "var(--colors-color-palette-causes-panel-muted)",
    "variable": "var(--colors-color-palette-causes-panel-muted)"
  },
  "colors.colorPalette.causesPanel.pattern": {
    "value": "var(--colors-color-palette-causes-panel-pattern)",
    "variable": "var(--colors-color-palette-causes-panel-pattern)"
  },
  "colors.colorPalette.pattern": {
    "value": "var(--colors-color-palette-pattern)",
    "variable": "var(--colors-color-palette-pattern)"
  },
  "colors.colorPalette.brand.primarySolid": {
    "value": "var(--colors-color-palette-brand-primary-solid)",
    "variable": "var(--colors-color-palette-brand-primary-solid)"
  },
  "colors.colorPalette.primarySolid": {
    "value": "var(--colors-color-palette-primary-solid)",
    "variable": "var(--colors-color-palette-primary-solid)"
  },
  "colors.colorPalette.brand.secondarySolid": {
    "value": "var(--colors-color-palette-brand-secondary-solid)",
    "variable": "var(--colors-color-palette-brand-secondary-solid)"
  },
  "colors.colorPalette.secondarySolid": {
    "value": "var(--colors-color-palette-secondary-solid)",
    "variable": "var(--colors-color-palette-secondary-solid)"
  },
  "colors.colorPalette.brand.accentHover": {
    "value": "var(--colors-color-palette-brand-accent-hover)",
    "variable": "var(--colors-color-palette-brand-accent-hover)"
  },
  "colors.colorPalette.accentHover": {
    "value": "var(--colors-color-palette-accent-hover)",
    "variable": "var(--colors-color-palette-accent-hover)"
  },
  "colors.colorPalette.secondary.200": {
    "value": "var(--colors-color-palette-secondary-200)",
    "variable": "var(--colors-color-palette-secondary-200)"
  },
  "colors.colorPalette.secondary.solid": {
    "value": "var(--colors-color-palette-secondary-solid)",
    "variable": "var(--colors-color-palette-secondary-solid)"
  },
  "colors.colorPalette.primary.300": {
    "value": "var(--colors-color-palette-primary-300)",
    "variable": "var(--colors-color-palette-primary-300)"
  },
  "colors.colorPalette.primary.solid.700": {
    "value": "var(--colors-color-palette-primary-solid-700)",
    "variable": "var(--colors-color-palette-primary-solid-700)"
  },
  "colors.colorPalette.solid.700": {
    "value": "var(--colors-color-palette-solid-700)",
    "variable": "var(--colors-color-palette-solid-700)"
  },
  "colors.colorPalette.onWarning": {
    "value": "var(--colors-color-palette-on-warning)",
    "variable": "var(--colors-color-palette-on-warning)"
  },
  "colors.colorPalette.successSubtle": {
    "value": "var(--colors-color-palette-success-subtle)",
    "variable": "var(--colors-color-palette-success-subtle)"
  },
  "colors.colorPalette.errorSubtle": {
    "value": "var(--colors-color-palette-error-subtle)",
    "variable": "var(--colors-color-palette-error-subtle)"
  },
  "colors.colorPalette.causeCard": {
    "value": "var(--colors-color-palette-cause-card)",
    "variable": "var(--colors-color-palette-cause-card)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar